import { updateServiceHistory } from "../../../store/slices/vehicleSlice";

export default function responseUpdateServiceHistory(response: any, api: any, arg: any) {
    console.log('update service history response', response);
    try {
        const data = response?.data || response;
        if (data) {
            // Update the vehicle in the Redux store
            api.dispatch(updateServiceHistory({
                id: arg.arguments?.vehicleId,
                serviceId: arg.arguments?.serviceId,
                data: data
            }));

            // Invalidate the fetchAllServiceHistories cache to refetch updated data
            api.util.invalidateQueries({ queryKey: ['fetchAllServiceHistories'] });
        }
        return data;
    } catch (error) {
        console.error('Response handler error:', error);
        return response?.data || response;
    }
}
